import { Flex } from '../UNSAFE_Flex';
import { TabBarContext } from './TabBarContext';
import { useTabBarContext } from './useTabBarContext';

import type { ComponentChildren, ContextType } from 'preact';

type TabBarContext = ContextType<typeof TabBarContext>;

type TabBarLayoutProps = {
  children: ComponentChildren;
  display?: TabBarContext['display'];
  layout?: TabBarContext['layout'];
};

/**
 * TabBarLayout is used to manage the display and layout of tab items within
 * its children.
 *
 * @param {TabBarLayoutProps} props TabBarLayout component props.
 * @returns {JSX.Element} TabBarLayout component element.
 */
export function TabBarLayout(props: TabBarLayoutProps) {
  const { children, display, layout } = props;

  const context = useTabBarContext();

  return (
    <TabBarContext.Provider
      value={{
        ...context,
        display,
        layout
      }}>
      <Flex direction="row" gap="8x" flex="1 0 auto">
        {children}
      </Flex>
    </TabBarContext.Provider>
  );
}
